/**
 * Created by Kotkin on 10.05.2017.
 */
import Carousel from './carousel';

export default Carousel;
